import {GroupAccidentNewYork} from './GroupAccidentNewYork';
import {NewYorkAccidentNewYork} from './NewYorkAccidentNewYork';
import {OrdinaryAccidentNewYork} from './OrdinaryAccidentNewYork';

export type AccidentNewYork = OrdinaryAccidentNewYork | GroupAccidentNewYork | NewYorkAccidentNewYork;

type ExhaustiveAccidentNewYorkOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryAccidentNewYork) => TReturn;
  Group: (group: GroupAccidentNewYork) => TReturn;
  NewYork: (newYork: NewYorkAccidentNewYork) => TReturn;
};

type PartialAccidentNewYorkOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryAccidentNewYork) => TReturn;
  Group?: (group: GroupAccidentNewYork) => TReturn;
  NewYork?: (newYork: NewYorkAccidentNewYork) => TReturn;
  _: (app: AccidentNewYork) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: AccidentNewYorkByTypeOptions<TReturn>
): options is ExhaustiveAccidentNewYorkOptionsByType<TReturn> =>
  !!options.Ordinary || (!!options.Group && !!options.NewYork);

type AccidentNewYorkByTypeOptions<TReturn> =
  | PartialAccidentNewYorkOptionsByType<TReturn>
  | ExhaustiveAccidentNewYorkOptionsByType<TReturn>;

export const matchAccidentNewYorkByType = <TReturn>(options: AccidentNewYorkByTypeOptions<TReturn>) => (
  app: AccidentNewYork
): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryAccidentNewYork':
    case 'ValidOrdinaryAccidentNewYork':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupAccidentNewYork':
    case 'ValidGroupAccidentNewYork':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkAccidentNewYork':
    case 'ValidNewYorkAccidentNewYork':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidAccidentNewYork = (accidentNewYork: AccidentNewYork) =>
  accidentNewYork.key === 'ValidOrdinaryAccidentNewYork' ||
  accidentNewYork.key === 'ValidGroupAccidentNewYork' ||
  accidentNewYork.key === 'ValidNewYorkAccidentNewYork';

export const units = [1, 2, 3, 4, 5, 6];

export const packages = ['Package 1', 'Package 2'];

export const plans = ['GVAP1NY'];
